import { createCondition as __create_condition__ } from "babel-runtime-jsx-plus";
import React from 'react';
import { CnMessage } from '@alife/cn-ui';
import { getPage } from "../../utils";
import { useFetchSchema } from '.';
var PAGE_TYPE_NUM_TO_STR = {
  5: 'L1',
  6: 'L2',
  7: 'L3'
};
export var PAGE_STATUS = {
  EDITING: '编辑中',
  DAILY: '日常发布',
  PROD: '线上发布',
  OBSOLETE: '已废弃'
};
export function AppView(props) {
  var _ref = props || {},
    app = _ref.app,
    showEmptyHint = _ref.showEmptyHint;
  var _ref2 = app || {},
    appCode = _ref2.appCode,
    name = _ref2.name,
    appName = _ref2.appName;
  var page = getPage();
  var isConex = page.isConex;
  if (appCode) {
    var url = isConex ? '/app/lowcode/index' : '/sop/workbench/site/page';
    return /*#__PURE__*/React.createElement("div", null, "\u5E94\u7528:", ' ', /*#__PURE__*/React.createElement("a", {
      target: "_blank",
      rel: "noreferrer",
      href: url + "?appCode=" + (appCode || ''),
      style: {
        wordWrap: 'break-word',
        wordBreak: 'break-all'
      }
    }, name || appName || appCode));
  }
  if (showEmptyHint) {
    return /*#__PURE__*/React.createElement(CnMessage, {
      type: "notice"
    }, "\u8BF7\u5148\u9009\u62E9\u7AD9\u70B9");
  }
  return null;
}
export function PageView(props) {
  var _ref3 = props || {},
    app = _ref3.app,
    page = _ref3.page,
    version = _ref3.version,
    before = _ref3.before,
    after = _ref3.after,
    showEmptyHint = _ref3.showEmptyHint;
  var _ref4 = app || {},
    appCode = _ref4.appCode;
  var _ref5 = page || {},
    pageId = _ref5.id,
    pageType = _ref5.pageType,
    pageTitle = _ref5.pageTitle;
  var _ref6 = version || {},
    pageVersion = _ref6.pageVersion,
    status = _ref6.status;
  var _useFetchSchema = useFetchSchema({
      pageSelect: {
        app: app,
        page: page,
        version: version
      }
    }),
    error = _useFetchSchema.error;
  if (appCode && pageId && pageType && PAGE_TYPE_NUM_TO_STR[String(pageType)] && pageVersion) {
    var editUrl = "/lowcode/edit?pageId=" + pageId;
    if (status === 'PROD') {
      editUrl += "&pubVersion=" + pageVersion;
    }
    var errNode = null;
    if (error) {
      errNode = /*#__PURE__*/React.createElement(CnMessage, {
        type: "error",
        style: {
          marginTop: 4
        }
      }, "\u9875\u9762\u8D44\u6E90\u83B7\u53D6\u5931\u8D25, \u8BF7\u91CD\u65B0\u53D1\u5E03", /*#__PURE__*/React.createElement("a", {
        target: "_blank",
        rel: "noreferrer",
        href: editUrl
      }, "\u9875\u9762"));
    }
    return /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'flex',
        flexFlow: 'column',
        // alignItems: 'center',
        justifyContent: 'center'
      }
    }, /*#__PURE__*/React.createElement("div", null, before || '页面版本', ":", ' ', /*#__PURE__*/React.createElement("a", {
      target: "_blank",
      rel: "noreferrer",
      href: editUrl
    }, pageTitle, "@", pageVersion, " (", PAGE_STATUS[status || 'EDITING'], ")")), __create_condition__([[function () {
      return status !== 'PROD';
    }, function () {
      return /*#__PURE__*/React.createElement(CnMessage, {
        type: "warning"
      }, "\u5F53\u524D\u9009\u62E9\u7684\u662F\u65E5\u5E38\u7248\u672C, \u9875\u9762\u300C", pageTitle, "\u300D\u53D1\u5E03\u5230\u7EBF\u4E0A\u540E, \u9700\u91CD\u65B0\u914D\u7F6E\u4E00\u6B21");
    }]]), after, errNode);
  }
  if (showEmptyHint) {
    return !pageId ? /*#__PURE__*/React.createElement(CnMessage, {
      type: "notice"
    }, "\u8BF7\u5148\u9009\u62E9\u9875\u9762") : /*#__PURE__*/React.createElement(CnMessage, {
      type: "notice"
    }, "\u8BF7\u5148\u9009\u62E9\u9875\u9762\u7248\u672C");
  }
  return null;
}